import { HttpErrorResponse } from '@angular/common/http';

/**
 * Extracts a numeric HTTP status from an unknown thrown error.
 * Accepts real {@link HttpErrorResponse} instances or plain objects with a
 * numeric `status` property (for DAL re-throw paths). Returns `undefined` for
 * non-HTTP failures.
 */
export function extractHttpStatus(error: unknown): number | undefined {
  if (error instanceof HttpErrorResponse) {
    return error.status;
  }

  if (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    typeof (error as { status: unknown }).status === 'number'
  ) {
    return (error as { status: number }).status;
  }

  return undefined;
}
